import { Button } from 'primereact/button';
import { Fieldset } from 'primereact/fieldset';
import { InputText } from 'primereact/inputtext';
import { ChangeEvent, useEffect, useState } from 'react';
import React from 'react';

interface Props {
  enabled: boolean;
  keyword: string;
  onChange: (value?: string) => void;
}

const KeywordComponent = ({ enabled, keyword, onChange }: Props) => {
  const [value, setValue] = useState<string>(keyword);

  useEffect(() => {
    setValue(keyword);
  }, [keyword]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };

  return (
    <Fieldset className="mb-1">
      <div className="flex flex-row align-items-center justify-content-center gap-1 ">
        <InputText
          className="text-center uppercase"
          min={3}
          max={10}
          name="main-key"
          disabled={!enabled}
          type="text"
          value={value}
          onChange={handleChange}
        />
        <Button
          icon="pi pi-sync"
          disabled={!enabled}
          onClick={() => onChange(value)}
          label="Get new"
        />
        <Button
          icon="pi pi-fast-forward"
          disabled={!enabled}
          onClick={() => onChange()}
          label="Next"
        />
      </div>
    </Fieldset>
  );
};

export default KeywordComponent;
